<template>
  <div id="aboutSearch">
    <div class="row">
      <div class="col-12 col-sm-12 col-md-7">
        <div class="breadcrumbs">
          <p :lang=selectedLanguageCode>{{ $t('message.you-are-here') }}</p>
          <ul>
            <li>
              <router-link tag="a" to="/">{{ $t('message.LEXIN') }}</router-link>
            </li>
            <li>
              <font-awesome-icon icon="arrow-right" class="right-agap"/>
              <router-link tag="a" :to="{ name: 'AboutComponent'}">{{ $t('message.about') }}</router-link>
            </li>
            <li>
              <font-awesome-icon icon="arrow-right" class="right-agap"/>
              <span>{{ $t('message.about-search') }}</span>
            </li>
          </ul>
        </div>
      </div>
      <Language></Language>
    </div>
    <div class="row">
      <div class="col-12">
        <h1>
          <span>{{ $t('message.about-search') }}</span>
        </h1>
        <div class="clearfix"></div>
        <div class="home-info">
          <h2 class="title">{{ $t('message.search-like-this-0') }}</h2>
          <ol>
            <li>{{ $t('message.search-like-this-1') }}</li>
            <li>{{ $t('message.search-like-this-3') }}</li>
            <li>{{ $t('message.search-like-this-6') }}</li>
            <li>{{ $t('message.search-like-this-9') }}</li>
            <li>{{ $t('message.search-like-this-10') }}</li>
            <li>{{ $t('message.search-like-this-12') }}</li>
            <li>{{ $t('message.search-like-this-11') }}</li>
            <li>{{ $t('message.search-like-this-14') }}</li>
          </ol>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Language from "./Language.vue";
export default {
  name: "AboutSearchComponent",
  components: {
    Language
  },
  data() {
     return {
       languageCodeList:[
        {lang:'eng',langISOCode:'en'},
        {lang:'nny',langISOCode:'nn'},
        {lang:'nbo',langISOCode:'nb'}
      ]
    }
  },
  computed: {
    selectedLanguageCode () {
      return this.languageCodeList.find(x=>x.lang==localStorage.getItem('lang')).langISOCode;
    },
  },
  created() {
    $("body,html").animate(
      {
        scrollTop: 0
      },
      60
    );
  }
};
</script>

